import React, { useCallback, useEffect, useRef, useState } from 'react';
import AgGridTable from '../../../../utilities/AgGridTable';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.min.css';
import { summaryData, report } from './planActualsData';

const TerritoryWiseGrid = (props) => {
    const [reportData, setReportData] = useState([]);
    const [rowData, setRowData] = useState(props.summary ? summaryData : reportData);

    const columnDefs = [
        { field: 'territory', headerName: 'TERRITORY', filter: false },
        {
            headerName: 'PLAN VS ACTUAL(YTD AUGUST)',
            children: [
                { field: 'planYtd', headerName: 'PLAN', filter: false },
                { field: 'actual', headerName: 'ACTUAL', filter: false },
                { field: 'balanceYtd', headerName: 'BALANCE', filter: false },
            ],
        },
        {
            headerName: 'SEP-DEC',
            children: [{ field: 'planMonth', headerName: 'PLAN', filter: false }],
        },
        {
            headerName: 'NO OF TRAINING DAYS',
            children: [
                { field: 'planTraining', headerName: 'PLAN', filter: false },
                { field: 'balanceTraining', headerName: 'BALANCE', filter: false },
            ],
        },
        { field: 'forecastSepToDec', headerName: 'FORECAST SEP-DEC', filter: false },
        { field: 'totalForecast', headerName: 'TOTLAL FORECAST', filter: false },
        { field: 'totalForecastTotalPlan', headerName: 'TOTAL FORECAST TOTAL PLAN', filter: false },
        { field: 'totalForecastPlan', headerName: 'TOTAL FORECAST PLAN', filter: false },
    ];

    const columnDefsReport = [
        { field: 'territory', headerName: 'TERRITORY', filter: false },
        { field: 'partnerName', headerName: 'PARTNER NAME', filter: false },
        { field: 'plan', headerName: 'PLAN', filter: false },
        { field: 'actuals', headerName: 'ACTUALS', filter: false },
        { field: 'balance', headerName: 'BALANCE', filter: false },
        { field: 'percentageOfCompletion', headerName: '% OF COMPLETION', filter: false },
        { field: 'percentageBalanceToComplete', headerName: '% BALANCE TO COMPLETE', filter: false },
    ];

    const gridRef = useRef();
    const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });

    const autoSizeAll = useCallback(() => {
        const allColumnIds = [];
        gridRef.current.columnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column?.getColId());
        });
        gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
    }, []);

    const onGridReady = useCallback((params) => {
        autoSizeAll();
    }, [autoSizeAll]);

    const processData = (data) => {
        const flattenedData = [];

        const flattenRowRecursive = (row, parentPath) => {
            if (row.isTotalDaysRow) {
                // Handle rendering for totalDays rows
                // For example, you can customize the appearance or skip rendering
                flattenedData.push({ ...row, dataPath: [...parentPath, row.orderCategory] });
                return;
            }

            // Your existing logic for processing regular rows
            if (props.summary) {
                row['territory'] = row.territory;
                row['planYtd'] = row.planOne;
                row['actual'] = row.actualOne;
                row['balanceYtd'] = row.balanceOne;
                row['planMonth'] = row.planTwo;
                row['planTraining'] = row.planThree;
                row['balanceTraining'] = row.balance;
                row['forecastSepToDec'] = row.forecastSepToDec;
                row['forecast'] = row.forecast;
                row['totalForecastTotalPlan'] = row.totalForecastTotalPlan;
                row['totalForecastPlan'] = row.totalForecastPlan;
                // ... (add other fields for summary)
            } else {
                row['territory'] = row.territory;
                row['partnerName'] = row.partnerName;
                row['plan'] = row.plan;
                row['actuals'] = row.actuals;
                row['balance'] = row.balance;
                row['percentageOfCompletion'] = row.percentageOfCompletion;
                row['percentageBalanceToComplete'] = row.percentageBalanceToComplete;
                // ... (add other fields for report)
            }

            const dataPath = [...parentPath, row.orderCategory];
            flattenedData.push({ ...row, dataPath });

            if (row.subCategories) {
                row.subCategories.forEach((underling) => flattenRowRecursive(underling, dataPath));
            }
        };

        data.forEach((row) => flattenRowRecursive(row, []));

        return flattenedData;
    };

    const onColumnStateChanged = useCallback((params) => {
        setStateData({
            columnState: params?.columnApi?.getColumnState(),
            columnGroupState: params?.columnApi?.getColumnGroupState(),
        });
    }, []);

    useEffect(() => {
        // Call insertTotalDaysObjects when the length of report is greater than 1
        if (report.length > 1) {
            setReportData((prevReport) => {
                const result = [...prevReport];
                const territoryMap = new Map();

                report.forEach((entry) => {
                    const { territory } = entry;

                    // Add the current entry to the result array
                    result.push(entry);

                    // Check if the territory has been encountered before
                    if (territoryMap.has(territory)) {
                        // Insert the totalDays object after the current entry
                        result.push({
                            totalDays: `Total-Training Days - ${territory}`,
                            isTotalDaysRow: true,
                            // You may need to add other properties here based on your requirements
                        });
                    }

                    // Mark the territory as encountered
                    territoryMap.set(territory, true);
                });

                return result;
            });
        }
    }, [report]);

    useEffect(() => {
        const dataToProcess = props.summary ? summaryData : reportData;

        if (dataToProcess && dataToProcess.length > 0) {
            try {
                const processedData = processData(dataToProcess);
                setRowData(processedData);
                autoSizeAll();
            } catch (error) {
                console.error('Error processing data:', error);
            }
        }
    }, [props.summary, reportData, autoSizeAll]);

    console.log(reportData);

    return (
        <>
            <div style={{ height: 400 }}>
                <AgGridTable
                    rowData={rowData}
                    columnDefs={props.summary ? columnDefs : columnDefsReport}
                    onGridReady={onGridReady}
                    onColumnStateChanged={onColumnStateChanged}
                    gridRef={gridRef}
                    hideCheckbox={true}
                    editable={false}
                    pagination={false}
                    showSidebar={false}
                    rowGroupPanelShow={'hide'}
                />
            </div>
        </>
    );
};

export default TerritoryWiseGrid;